// models component
import ChatRoom from '@/models/ChatRoom'

export default class ChatRoomFetch {
    static of() {
        return Promise.resolve()
            .then(function () {
                return ChatRoom.api()
                    .fetch()
                    .then(function (result) {
                        return result
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
